<style scoped lang="scss">
.container10{
  margin-top: 80px;
}
.container10 h1{
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
  font-size: 60px;
  color: #014492;
  font-weight: 550;
}
.cons{
  display: none;
}
.container10 h2{
  font-size: 34px;
  color: #014492;
}
.container10 .a{
  width: 1100px;
  height: 6px;
  margin-top: 30px;
  margin-bottom: 40px;
  background: #ccc;
  position: relative;
}
.container10 .a span{
  width: 50px;
  height: 6px;
  position: absolute;
  left: 0;
  top: 0;
  background: #014492;
}
.strengths{
  display: flex;
  margin-top: 30px;
  li{
    flex:1;
    text-align: center;
    border-right: 1px solid #eee;
    padding:0 40px;
    &:last-child{
      border: 0;
    }
    h4{
      font-size: 18px;
      margin-bottom: 10px;
      color:#014492;
    }
  }
}
.download{
  display: flex;
  flex-wrap: wrap;
  border-left: 1px solid #E4E6EA;
  li{
    width:50%;
    padding:20px 30px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #E4E6EA;
    border-right: 1px solid #E4E6EA;
    font-size: 16px;
    cursor: pointer;
    &:nth-of-type(1){
      border-top: 1px solid #E4E6EA;
    }
    &:nth-of-type(2){
      border-top: 1px solid #E4E6EA;
    }
    &:hover{
      color:#014492;
    }
  }
  .btn-primary{
    font-size: 14px;
    span{
      margin-right: 7px;
    }
  }
  .mr41{
    display: block;
  }
  .mr42{
    display: none;
  }
}
.table{
  tr{
    td:first-child{
      background: #F6FAFD;
    }
  }
}
.c-title small{
  margin-top: 10px;
}
.desc{
  font-size: 16px;
}
.effect-lists{
  //display: block!important;
  justify-content: space-between;
  flex-wrap:wrap;
  overflow: auto;
}
</style>
<style scoped>
@import url("../../assets/sanger.css");
@import url("../../assets/service.css");
</style>
<template>
  <div class="wrap wrap-tec">
<!--    <div class="banner">-->
<!--      <img src="@/assets/img/产品及服务/基因调控/基因编辑/banner.png" class="img-fluid">-->
<!--      <div class="info">-->

<!--      </div>-->
<!--    </div>-->
    <div class="container container10">
      <h1>circRNA过表达质粒构建</h1>
      <h2 class="mt10">Construction of circRNA Overexpression Plasmid</h2>
      <div class="a"><span></span></div>
    </div>
    <section>
      <div class="breads container" style="overflow:auto;line-height: 48px;padding-left: 10px;margin-bottom:  20px;">
        <bread></bread>
      </div>
      <div class="container" style="margin-bottom: 30px;">
        <p class="desc" style="margin-bottom: 20px;">	环状 RNA（circRNA）是一类特殊的非编码 RNA，区别于线性 RNA。它们通过共价键连接形成环状结构，不具备 5'末端帽和 3'末端 poly(A)尾。这种闭合的环状构造使circRNA 在生物体内具有更高的稳定性，能够抵御核酸酶的降解。circRNA 在发育生物学和疾病研究等领域被认为具有重要的调控功能和应用前景。</p>
        <p class="desc">	circRNA 的形成机制</p>
        <p class="desc">	侧翼内含子自身互补配对：外显子两端的侧翼内含子包含多对反向互补序列，这些序列促使内含子配对，使下游的剪接供体（Splice-Donor）与上游的剪接受体（Splice-Acceptor）靠近，从而结合形成环状 RNA。</p>
        <p class="desc">	RNA 结合蛋白驱动环化：环化外显子两端的侧翼内含子含有 RNA 结合蛋白（RBPs）识别的特定序列。RBP 分别与两翼内含子特异基序结合后，会形成二聚体，促进两翼内含子互相靠近，进而连接成环。</p>
        <p class="desc">	套索驱动环化：在 mRNA 前体剪接时，外显子跳读可能产生包含外显子和内含子的套索中间体，随后经过反向剪接形成环状 RNA。</p>
        <p class="desc">	这些形成机制赋予 circRNA 独特的结构特征，如抗降解能力和较长的半衰期，使其在细胞内稳定存在，可能发挥重要的生物学功能。</p>
      </div>
      <div class="container">
        <div class="gene_img1  con" style="width: 560px; margin-left: auto;margin-right: auto;margin-top: 30px;"><img src="@/assets/img/产品及服务/基因调控/基因干扰/circRNA1.jpg" class="img-fluid"></div>
        <div class="gene_img1  cons" style="width: 560px; margin-left: auto;margin-right: auto;margin-top: 30px;"><img src="@/assets/img/产品及服务/基因调控/基因干扰/circRNA1.jpg" class="img-fluid"></div>
        <p style="text-align: center;margin-top: 30px;">A：侧翼内含子自身互补配对; B：RNA 结合蛋白驱动;  C：mRNA 前体剪接时外显子跳读形成套索。</p>
        <p class="desc" style="margin-top: 30px">
          为了深入研究 circRNA 的功能，科学家们开发了 circRNA 过表达质粒，这些质粒能够在细胞或动物体内高效表达特定的环状 RNA。擎科生物使用的 pLV-CiR 载体通过多克隆位点两翼的反向重复序列，促进 RNA 的成环剪接，从而实现 circRNA 的过表达。这些工具为研究 circRNA 在基因调控、细胞信号传导等方面的功能提供了便利。
        </p>
      </div>
      <div class="c-title">服务内容<small>Service Details</small></div>
      <div class="container">
        <p :style="{marginBottom: '25px'}">
          擎科生物提供 circRNA 过表达质粒定制服务，以支持基因功能研究和疾病机制探讨。
        </p>
        <el-table :data="serviceList" border :header-cell-style="{background: '#F6FAFD'}">
          <el-table-column label="产品名称" align="center" prop="product"></el-table-column>
          <el-table-column label="规格" align="center" prop="model"></el-table-column>
          <el-table-column label="周期（工作日）" align="center" prop="cycle"></el-table-column>
          <el-table-column label="备注" prop="remark">
            <template slot-scope="scope">
              <p>1.客户提供基因名称/基因 ID/转录本 NM 号和物种名称，我方负责构建质粒</p>
              <p>2.因 circRNA 成环机制复杂，成功构建质粒并不能保证其在细胞中一定可以正常成环</p>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="c-title">服务流程<small>Service Process</small></div>
      <div class="container">
        <div style="margin-left: auto;margin-right: auto;margin-top: 30px;"><img src="@/assets/img/产品及服务/service-flow-circRNA.png" class="img-fluid"></div>
      </div>

      <div class="container">
        <qk-consult type="circRNA"/>
      </div>
    </section>
  </div>
</template>
<script>
import { resourceColumns, resourceDownloads } from '@/services/api.index'
import bread from "@/components/bread"
export default {
  components:{
    bread
  },
  data () {
    return {
      serviceList: [
        {product: 'circRNA 过表达质粒定制', model: '4 μg 质粒、穿刺菌、阴性对照质粒 ', cycle: '5~15', remark: ''}
      ],
      currentType: -1,
      currentService: -1,
      types: [
        {name: '基因干扰', img: '2', ref: '/products/Gene_interference'},
        {name: '蛋白表达', img: '3', ref: '/products/Protein_expression'},
        {name: '甲基化检测', img: '4', ref: '/products/Methylation_detection'},
        {name: '基因过表达', img: '5', ref: ''},
        {name: '基因panel定制及SNP分型', img: '6', ref: '/products/Gene_SNP'},
      ],
      types1: [
        {name: 'sgRNA质粒构建', img: '2', ref: ''},
        {name: 'sgRNA文库构建', img: '3', ref: ''},
        {name: 'CRISPRi/CRISPRa服务', img: '4', ref: ''}
      ],
      page: 0,
      total: 0,
      resourcesLists: [],
      categoryId: ''
    }
  },
  created () {
    this.getResourceColumns()
  },
  methods: {
    // 资源栏目
    getResourceColumns () {
      resourceColumns().then(res => {
        this.menuLists = res.data
        this.total = this.baseMethods.getTotal(res)
        this.getResourcesLists(res.data[0].id)
      })
    },
    // 根据栏目id获取资源列表
    getResourcesLists (id) {
      this.categoryId = id
      resourceDownloads(1, this.page, 20).then(res => {
        this.resourcesLists = res.data
        this.total = this.baseMethods.getTotal(res)
      })
    },
    // 下载
    bindDownLoad (imgsrc, name) {
      this.baseMethods.downloadImage(imgsrc, name)
    },
    downFile (item) {
      this.baseMethods.courseDownload(item.resourceFile.visitedUrl, item.name)
    },
    // 翻页
    changePage (value) {
      this.page = value - 1
      this.getResourcesLists(this.categoryId)
    },

  }
}
</script>



// WEBPACK FOOTER //
// src/views/products/circRNA_overexpression.vue